export default {
    props: {
        messagesApply: {
            type: String,
            default: undefined,
            kComposite: 'messages.apply'
        }, 
        messagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.cancel'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoFlatColorPicker/Messages.js